import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import JsonView from '@uiw/react-json-view';
import PropTypes from 'prop-types';
import { useState } from 'react';

const JsonViewDialog = ({ jsonData, open, closeModel }) => {
  const [copied, setCopied] = useState(false);

  const closeDialog = (_, reason) => {
    if (reason !== 'backdropClick') {
      closeModel();
      setCopied(false);
    }
  };

  const handleCopyJson = () => {
    setCopied(true);
    navigator.clipboard.writeText(JSON.stringify(jsonData, null, 2));
  };

  return (
    <Dialog open={!!open} onClose={closeDialog} aria-labelledby='json-view-dialog-title'>
      <DialogTitle id='json-view-dialog-title'>
        <Grid container justifyContent='space-between' alignItems='center'>
          <Grid item>
            <Typography variant='h6'>Event Payload</Typography>
          </Grid>
          <Grid item>
            <Tooltip title={copied ? 'Copied!' : 'Copy JSON'}>
              <IconButton size='small' onClick={handleCopyJson}>
                <ContentCopyIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 560, minHeight: 400 }}>
        <JsonView collapsed={250} value={jsonData} enableClipboard={false} />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} size='small' variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

JsonViewDialog.propTypes = {
  jsonData: PropTypes.shape({}).isRequired,
  open: PropTypes.bool.isRequired,
  closeModel: PropTypes.func.isRequired,
};

export default JsonViewDialog;
